<template>
  <div class="loading">
    <b-row>
      <b-col lg="12">
        <div class="sk-double-bounce">
          <div class="sk-child sk-double-bounce1"></div>
          <div class="sk-child sk-double-bounce2"></div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "LoadingCard",
  props: ["height", "width"]
};
</script>
